module.exports = __webpack_public_path__ + "media/images/details__prizeBox__event__first-a06d4ea66ab3d84f6d985f32c9e29207.png";